import React, { useEffect } from "react";
import { CardHeader, CardContent, CardActions, } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import EngineeringIcon from '@mui/icons-material/Engineering';
import { colors } from '../../assets/colors';
import MainButton from "./MainButton";
import { Modal } from 'antd';

const MainModal = (props) => {
    const { open, handleOpen, handleClose, title, subTitle, bodyModal, buttonActions, formSubmit, size, centrado } = props;

    const handleModalOpen = () => {
        console.log('Modal abierto');
    };

    useEffect(() => {
        if (open)
            if (handleOpen)
                handleOpen();
    }, [open]);

    return (
        <Modal
        title={
            <CardHeader
                avatar={
                    <Avatar 
                            sx={{width: 'auto', borderRadius: 0 }}
                            src="img/airbox/airbox_modal.png"
                            aria-label="modal-avatar"
                        />
                }
                title={title}
                subheader={subTitle}
                sx={{
                    paddingBottom: '0.3rem',
                    paddingTop: 0,
                }}
            />
        }
        open={open}
        onOk={handleClose}
        onCancel={handleClose}
        destroyOnClose={true}
        footer={null}
        centered={true}
        style={{
            top: centrado ? '50%' : '50px',
            transform: centrado ? 'translateY(-50%)' : 'none',
        }}
        width={size === 'lg' ? 1000 : size === 'md' ? 800 : size === 'xs' ? 600 : 600}
    >
            <form onSubmit={formSubmit} >
                <CardContent
                    sx={{
                        padding: 0,
                        margin: '0 -0.5rem',
                    }}
                >
                    {bodyModal}
                </CardContent>

                <CardActions
                    sx={{
                       
                        margin: '0.5rem -1rem -1rem -1rem',
                        borderTop: `solid 0.1rem #f87115`,
                    }}
                >
                    {buttonActions}
                    <MainButton
                        //key='btn-modal-cancel'
                        onClick={handleClose}
                        title={'Cerrar'}
                        typeStyle={''}
                        color={'warning'}
                    />
                </CardActions>
            </form>
        </Modal >
    )
}

export default MainModal;